

















import { ValidationProvider } from 'vee-validate';
import type { WithRefs } from 'vue-typed-refs';
import { ValidatableMixin } from '../../mixins';
import SldsInput from '../Input/Input.vue';

export type Refs = {
  input: InstanceType<typeof SldsInput>;
};

export default (
  ValidatableMixin as WithRefs<Refs, typeof ValidatableMixin>
).extend({
  name: 'AppValidateableTextField',
  components: {
    ValidationProvider,
    SldsInput,
  },
  inheritAttrs: false,
  methods: {
    focus() {
      this.$refs.input.focus();
    },
  },
});
